var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.parent_class},[(_vm.isVisible)?_vm._l((_vm.data),function(product,index){return _c('div',{key:index,class:_vm.child_class},[_c('menuItem',{attrs:{"data":product,"index":index,"design_type":_vm.design_type,"btn_design_type":_vm.btn_design_type}})],1)}):_c('div',{ref:"placeholder",staticClass:"w-100"})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6b152aae","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/restaurant-v2/menuList.vue
// module id = null
// module chunks = 